module.exports = __webpack_public_path__ + "img/artboard15.577c79b8.png";